(function (window, document) {
  'use strict';
  let config, market;
  try {
    config = JSON.parse(document.getElementById('hlx-attribution-config')?.textContent || 'null');
    const stores = {bg_hlp:'bg-healthlabs-pharm.myshopify.com'};
    if (window.HLXAttribution || config?.schemaVersion !== 1 || config.enabled !== true
        || stores[config.storeKey] !== config.shop || window.Shopify?.shop !== config.shop) return;
    const host = window.location?.hostname;
    market = config.markets.find(row => row.hostname === (host === config.shop ? config.hostname : host));
    if (!market || market.countryCode !== 'BG' || config.country !== 'BG' || market.hostname !== 'bgn.healthlabsexpress.com' || config.hostname !== 'bgn.healthlabsexpress.com' || config.markets.length !== 1) return;
  } catch (_) { return; }
  const {shop, storeKey} = config;
  const country = market.countryCode, hostname = market.hostname;
  const countries = new Set(config.markets.map(row => row.countryCode));
  const cookieNames = { gclid: 'dilcg', gbraid: 'gbraid', wbraid: 'wbraid' };
  const clickPattern = /^[A-Za-z0-9_-]{1,255}$/;
  let capturedSearch = null;
  const consentKeys = ['ad_storage', 'analytics_storage', 'ad_user_data', 'ad_personalization'];
  const registryKey = 'hlx_' + storeKey + '_lead_restrictions_v1';
  const registryTtl = 86400000;
  const registry = [];
  const cycles = new Set();

  // Country policy is generated from the same source as the receiver. Ambiguous
  // national inputs require +E164; never strip an arbitrary run of zeroes.
  function normalizePhone(raw, countryCode, prefix) {
    if (typeof raw !== 'string' || raw.length > 48 || /[^+0-9 ()\-.]/.test(raw)) return '';
    const code = String(countryCode || '').toUpperCase().replace(/^UK$/, 'GB');
    const policy = config.phonePolicy[code];
    if (!policy || prefix !== policy.dial) return '';
    let number = raw.replace(/[ ()\-.]/g, '');
    if (!/^\+?[0-9]+$/.test(number)) return '';
    if (number.startsWith('+')) return /^\+[1-9][0-9]{7,14}$/.test(number) ? number : '';
    if (number.startsWith('00')) {
      if (!policy.international00) return '';
      number = '+' + number.slice(2);
    } else {
      if (!policy.allowNational) return '';
      if (policy.trunk && number.startsWith(policy.trunk)) number = number.slice(policy.trunk.length);
      if (number.length < policy.nationalMin || number.length > policy.nationalMax
          || (!policy.preserveLeadingZero && number.startsWith('0'))) return '';
      number = policy.dial + number;
    }
    return /^\+[1-9][0-9]{7,14}$/.test(number) ? number : '';
  }

  async function enhancedPhone(phone) {
    if (typeof phone !== 'string' || /[^+0-9]/.test(phone) || !/^\+[1-9][0-9]{7,14}$/.test(phone)
        || consent().ad_user_data !== 'granted') return '';
    let timer;
    try {
      // Hash the '+' too. The offline export uses exactly this SHA-256 preimage.
      const digest = await Promise.race([
        window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(phone)),
        new Promise(resolve => { timer = window.setTimeout(() => resolve(null), 1000); })
      ]);
      if (!digest || consent().ad_user_data !== 'granted') return '';
      return Array.from(new Uint8Array(digest), value => value.toString(16).padStart(2, '0')).join('');
    } catch (_) { return ''; }
    finally { if (timer !== undefined) window.clearTimeout(timer); }
  }

  function consent() {
    const snapshot = { ad_storage: 'unknown', analytics_storage: 'unknown', ad_user_data: 'unknown', ad_personalization: 'unknown', observedAt: new Date().toISOString(), source: 'shopify_customer_privacy' };
    try {
      const privacy = window.Shopify?.customerPrivacy;
      const required = ['marketingAllowed', 'analyticsProcessingAllowed', 'saleOfDataAllowed'];
      if (!required.every(name => typeof privacy?.[name] === 'function')) return snapshot;
      const marketing = privacy.marketingAllowed(), analytics = privacy.analyticsProcessingAllowed(), sharing = privacy.saleOfDataAllowed();
      const signal = value => value === true ? 'granted' : value === false ? 'denied' : 'unknown';
      snapshot.ad_storage = signal(marketing);
      snapshot.analytics_storage = signal(analytics);
      snapshot.ad_user_data = snapshot.ad_personalization = marketing === false || sharing === false ? 'denied' : marketing === true && sharing === true ? 'granted' : 'unknown';
    } catch (_) {}
    return snapshot;
  }

  function readCookie(name) {
    try {
      const prefix = name + '=';
      const row = document.cookie.split(';').map(value => value.trim()).find(value => value.startsWith(prefix));
      return row ? decodeURIComponent(row.slice(prefix.length)) : '';
    } catch (_) { return ''; }
  }

  function writeCookie(name, value) {
    try { document.cookie = name + '=' + encodeURIComponent(value) + '; Max-Age=2592000; Path=/; Secure; SameSite=Lax'; } catch (_) {}
  }

  function clearCookie(name) {
    for (const domain of ['', '; Domain=' + window.location.hostname, ...(hostname.endsWith('.healthlabsexpress.com') ? ['; Domain=healthlabsexpress.com'] : hostname.endsWith('.herbalhaus.store') ? ['; Domain=herbalhaus.store'] : [])]) {
      try { document.cookie = name + '=; Max-Age=0; Path=/; Secure; SameSite=Lax' + domain; } catch (_) {}
    }
  }

  function uuid() {
    if (typeof window.crypto?.randomUUID === 'function') return window.crypto.randomUUID();
    if (typeof window.crypto?.getRandomValues !== 'function') throw new Error('Submission identity unavailable');
    const values = window.crypto.getRandomValues(new Uint8Array(16));
    values[6] = (values[6] & 15) | 64;
    values[8] = (values[8] & 63) | 128;
    const hex = Array.from(values, value => value.toString(16).padStart(2, '0')).join('');
    return [hex.slice(0, 8), hex.slice(8, 12), hex.slice(12, 16), hex.slice(16, 20), hex.slice(20)].join('-');
  }

  function synchronize() {
    const state = consent();
    // Owner decision (2026-09-26): click IDs are business attribution data (partner sub-ids, order
    // linking). They are captured from the landing URL and kept whatever the banner says; consent
    // only governs the Google tags.
    if (capturedSearch !== window.location.search) {
      const params = new URLSearchParams(window.location.search);
      const landing = Object.fromEntries(Object.entries(cookieNames).map(([key, name]) => {
        const value = params.get(key) || '';
        return [name, clickPattern.test(value) ? value : ''];
      }));
      // A new click generation replaces all three fields, including absent ones.
      if (Object.values(landing).some(Boolean)) {
        for (const name of Object.values(cookieNames)) clearCookie(name);
        for (const [name, value] of Object.entries(landing)) {
          if (value) writeCookie(name, value);
        }
      }
      capturedSearch = window.location.search;
    }
    if (!/^[A-Za-z0-9]{32}$/.test(readCookie('controlid'))) {
      try { writeCookie('controlid', uuid().replace(/-/g, '')); } catch (_) {}
    }
    updateLinks(readClicks());
    return state;
  }

  function readClicks() {
    return Object.fromEntries(Object.entries(cookieNames).map(([key, name]) => {
      const value = readCookie(name);
      return [key, clickPattern.test(value) ? value : ''];
    }));
  }

  function updateLinks(clicks) {
    for (const link of document.querySelectorAll('#plink1, #plink2, #plink3, #plink4')) {
      try {
        const url = new URL(link.href, window.location.href);
        if (url.origin !== 'https://crm.healthlabspharm.com') continue;
        for (const [name, value] of Object.entries(clicks)) {
          if (value) url.searchParams.set(name, value);
          else url.searchParams.delete(name);
        }
        link.href = url.href;
      } catch (_) {}
    }
  }

  function context(eventId, country) {
    if (country !== market.countryCode) throw new Error('Unresolved lead country');
    const current = synchronize();
    return { schemaVersion: 1, eventId, stage: 'lead', source: { shop, storeKey, country, orderId: '', lineItemId: '' }, consent: current, clicks: readClicks() };
  }

  function capability() {
    const bytes = window.crypto.getRandomValues(new Uint8Array(32));
    return Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
  }

  function consentStates(value) {
    if (!value || !consentKeys.every(key => ['granted', 'unknown', 'denied'].includes(value[key]))) return null;
    return Object.fromEntries(consentKeys.map(key => [key, value[key]]));
  }

  function saveRegistry() {
    const now = Date.now();
    for (let index = registry.length - 1; index >= 0; index--) {
      if (now - registry[index].createdAt >= registryTtl) registry.splice(index, 1);
    }
    while (registry.length > 16) registry.shift();
    try { window.sessionStorage.setItem(registryKey, JSON.stringify(registry)); } catch (_) {}
  }

  function loadRegistry() {
    try {
      const raw = window.sessionStorage.getItem(registryKey);
      if (!raw || raw.length > 32768) return;
      const rows = JSON.parse(raw);
      if (!Array.isArray(rows) || rows.length > 16) return;
      const now = Date.now();
      for (const row of rows) {
        if (!row || typeof row.eventId !== 'string' || !/^GRapp-[a-f0-9]{32}$/.test(row.eventId)
            || typeof row.updateKey !== 'string' || !/^[a-f0-9]{64}$/.test(row.updateKey)
            || !Number.isSafeInteger(row.createdAt) || row.createdAt > now || now - row.createdAt >= registryTtl
            || row.source?.shop !== shop || row.source?.storeKey !== storeKey || !countries.has(row.source?.country)
            || row.source.orderId !== '' || row.source.lineItemId !== '' || !consentStates(row.initialConsent)
            || registry.some(entry => entry.eventId === row.eventId)) continue;
        let restriction = null;
        if (row.restriction) {
          const states = consentStates(row.restriction), observed = Date.parse(row.restriction.observedAt);
          if (!states || row.restriction.source !== 'shopify_customer_privacy' || typeof row.restriction.observedAt !== 'string'
              || !Number.isFinite(observed) || observed > now + 300000 || consentKeys.every(key => states[key] === 'granted')) continue;
          restriction = { ...states, observedAt: row.restriction.observedAt, source: 'shopify_customer_privacy' };
        }
        registry.push({ eventId: row.eventId, updateKey: row.updateKey, createdAt: row.createdAt,
          source: { shop, storeKey, country: row.source.country, orderId: '', lineItemId: '' },
          initialConsent: consentStates(row.initialConsent), restriction,
          ackHash: typeof row.ackHash === 'string' && /^[a-f0-9]{64}$/.test(row.ackHash) ? row.ackHash : '' });
      }
    } catch (_) {}
  }

  async function digest(text) {
    let timer;
    try {
      const result = await Promise.race([
        window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(text)),
        new Promise((_, reject) => { timer = window.setTimeout(() => reject(new Error('Restriction hash timeout')), 1000); })
      ]);
      return Array.from(new Uint8Array(result), byte => byte.toString(16).padStart(2, '0')).join('');
    } finally { if (timer !== undefined) window.clearTimeout(timer); }
  }

  function restrictionCycle(entry) {
    if (cycles.has(entry) || !entry.restriction || !registry.includes(entry)) return;
    const revision = entry.restriction;
    cycles.add(entry);
    (async () => {
      const canonical = JSON.stringify(Object.fromEntries(Object.keys(revision).sort().map(key => [key, revision[key]])));
      const hash = await digest(canonical);
      if (hash === entry.ackHash) return;
      const receiptId = await digest(shop + '|' + entry.eventId + '||');
      const body = JSON.stringify({ tracking_action: 'restrict_consent', schemaVersion: 1, eventId: entry.eventId,
        source: entry.source, updateKey: entry.updateKey, consent: revision });
      for (let attempt = 0; attempt < 3; attempt++) {
        if (attempt) await new Promise(resolve => window.setTimeout(resolve, attempt === 1 ? 1000 : 3000));
        if (entry.restriction !== revision || !registry.includes(entry)) return;
        const abort = new AbortController();
        const timer = window.setTimeout(() => abort.abort(), 5000);
        try {
          const response = await window.fetch('https://crm.healthlabspharm.com/HLMAPI-GET_gateway.php', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body, signal: abort.signal,
            credentials: 'omit', referrerPolicy: 'strict-origin'
          });
          if (!response.ok) throw new Error('Restriction rejected');
          const ack = await response.json();
          if (ack?.schemaVersion !== 1 || ack.accepted !== true || ack.eventId !== entry.eventId || ack.receiptId !== receiptId
              || ack.restrictionHash !== hash || typeof ack.pendingIntake !== 'boolean') throw new Error('Restriction receipt invalid');
          if (entry.restriction === revision) { entry.ackHash = hash; saveRegistry(); }
          return;
        } catch (_) { /* Retry metadata only; business success is independent. */ }
        finally { window.clearTimeout(timer); }
      }
    })().catch(() => {}).finally(() => {
      cycles.delete(entry);
      if (entry.restriction !== revision) restrictionCycle(entry);
    });
  }

  function restrictEntries(state, retry = false) {
    saveRegistry();
    for (const entry of registry) {
      const baseline = entry.restriction || entry.initialConsent;
      // Missing API is not evidence of withdrawal of an earlier observed grant.
      // Cookies/emission still fail closed; only an observed denial is durable.
      const states = Object.fromEntries(consentKeys.map(key => [key, state[key] === 'denied' ? 'denied' : baseline[key]]));
      if (consentKeys.some(key => states[key] !== baseline[key])) {
        entry.restriction = { ...states, observedAt: state.observedAt, source: state.source };
        entry.ackHash = '';
        saveRegistry();
        restrictionCycle(entry);
      } else if (retry) restrictionCycle(entry);
    }
  }

  function createFormSession() {
    let pending = null;
    let busy = null;
    return Object.freeze({
      submit(fields, country) {
        if (busy) return busy;
        const fingerprint = JSON.stringify([country, Object.entries(fields).sort(([a], [b]) => a.localeCompare(b))]);
        let payload, eventId, entry;
        try {
          if (!pending || pending.fingerprint !== fingerprint) {
            const entry = { eventId: 'GRapp-' + uuid().replace(/-/g, ''), updateKey: capability(),
              createdAt: Date.now(), source: { shop, storeKey, country, orderId: '', lineItemId: '' },
              initialConsent: consentStates(consent()), restriction: null, ackHash: '' };
            if (country !== market.countryCode) throw new Error('Unresolved lead country');
            registry.push(entry); saveRegistry();
            pending = { fingerprint, eventId: entry.eventId, entry };
          }
          eventId = pending.eventId;
          entry = pending.entry;
          const tracking = context(eventId, country);
          payload = { ...fields, shop: hostname, control: eventId, tracking_context: tracking, tracking_update_key: pending.entry.updateKey,
            gclidParam: tracking.clicks.gclid, gbraidParam: tracking.clicks.gbraid, wbraidParam: tracking.clicks.wbraid };
          if (payload.IMETA_partnerTrackingURLTemplate || payload.IMETA_partnerTrackingURL) {
            const url = window.atob(payload.IMETA_partnerTrackingURLTemplate || payload.IMETA_partnerTrackingURL).replace(/\{(gclid|gbraid|wbraid)\}/gi, (_, key) => tracking.clicks[key.toLowerCase()]);
            payload.IMETA_partnerTrackingURL = window.btoa(url);
          }
        } catch (error) { return Promise.reject(error); }
        const abort = new AbortController();
        const timer = window.setTimeout(() => abort.abort(), 20000);
        busy = Promise.resolve().then(() => {
          // Retain every grant attempted by this identity, including retries.
          // A lost ACK cannot tell us whether that grant reached the receipt.
          for (const key of consentKeys) {
            if (payload.tracking_context.consent[key] === 'granted') entry.initialConsent[key] = 'granted';
          }
          saveRegistry();
          restrictEntries(consent());
          return window.fetch('https://crm.healthlabspharm.com/HLMAPI-GET_gateway.php', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), signal: abort.signal, credentials: 'omit', referrerPolicy: 'strict-origin'
          });
        }).then(async response => {
          if (!response.ok) throw new Error('Lead gateway rejected the request');
          const receipt = await response.json();
          const expectedReceipt = await digest(shop + '|' + eventId + '||');
          if (receipt?.schemaVersion !== 1 || receipt.accepted !== true || receipt.eventId !== eventId || receipt.receiptId !== expectedReceipt || typeof receipt.duplicate !== 'boolean') throw new Error('Lead gateway receipt is invalid');
          pending = null;
          restrictEntries(consent());
          return { eventId, receiptId: receipt.receiptId, duplicate: receipt.duplicate };
        }).finally(() => { window.clearTimeout(timer); busy = null; });
        return busy;
      }
    });
  }

  window.HLXAttribution = Object.freeze({
    version: 1, storeKey, shop, country, hostname, consent, createFormSession, normalizePhone, enhancedPhone,
    cookie(name) {
      synchronize();
      if (![...Object.values(cookieNames), 'controlid'].includes(name)) return undefined;
      const value = readCookie(name);
      return (name === 'controlid' ? /^[A-Za-z0-9]{32}$/ : clickPattern).test(value) ? value : undefined;
    }
  });
  loadRegistry();
  document.addEventListener('visitorConsentCollected', () => restrictEntries(synchronize()));
  document.addEventListener('hlx:consent-ready', () => restrictEntries(synchronize()));
  window.addEventListener?.('online', () => restrictEntries(synchronize(), true));
  restrictEntries(synchronize(), true);
})(window, document);
